import { useEffect, useState } from "react";
import {jsPDF} from "jspdf";
import { autoTable } from 'jspdf-autotable'
import * as XLSX from "xlsx";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedNodes, setSelectedNodes } from "../redux/selectedNodesSlice";
import { selectnodess } from "../redux/nodesSlice";
import GenerateReportSelectorModal from "../components/GenerateReportSelectorModal";
import { toPng } from "html-to-image";

const formatHeaderLabel = (label) => {
  return label
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase())
    .trim();
};



const htmlToPlainText = (html) => {
  const plainText = html?.replace(/<[^>]*>/g, "");
  const cleanText = plainText?.replace(/&[^;]+;/g, "");
  const words = cleanText?.split(/\s+/);
  return words?.slice(0, 20).join(" ");
};
const getHongKongTimestamp = () => {
  const now = new Date().toLocaleString("en-GB", {
    timeZone: "Asia/Hong_Kong",
    hour12: false,
  });
  const [date, time] = now.split(", ");
  const formattedDate = date.split("/").reverse().join("-");
  const formattedTime = time.replace(/:/g, "-");
  return `${formattedDate}_${formattedTime}`;
};


export function GenerateReport() {
  const dispatch = useDispatch();
  const editedNewNodes = useSelector(selectnodess);
  const selectedNodes = useSelector(selectSelectedNodes);
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

 


  const generateReport = async (selectedFields) => {
    const selectedNodeIds = selectedNodes?.map((node) => node.nodeId || node.id);
    const allorg = editedNewNodes.filter((item) =>
      selectedNodeIds.includes(item.id)
    );

    const filteredData = allorg?.map((item, index) => {
      const rowData = { ID: index + 1 };
      Object.keys(selectedFields)?.forEach((field) => {
        if (selectedFields[field]) {
          if (field === "location") {
            rowData[formatHeaderLabel(field)] = item?.data?.[field]?.address || "----";
          } else if (field === "TotalPaidUpCapital") {
            const amount = item?.data?.[field] || 0;
            const currency = item?.data?.TotalCurrency || "";
            const formattedAmount = new Intl.NumberFormat().format(amount);
            rowData[formatHeaderLabel(field)] = currency
              ? `${currency === "USD" ? "$" : currency} ${formattedAmount}`
              : formattedAmount;
          } else if (field === "Remarks") {
            rowData[formatHeaderLabel(field)] = htmlToPlainText(item?.data?.[field]);
          } else if (field === "directors") {
            rowData[formatHeaderLabel(field)] = Array.isArray(item?.data?.[field])
              ? item?.data?.[field].join(", ")
              : item?.data?.[field] || "----";
          } else if (field === "shareholders") {
            const shareHolders = item?.data?.shareHolders || [];
            const jointVentures = item?.data?.JointVentureCompanies || [];

            const shareholderDetails = shareHolders.map(sh => {
              const childOrg = editedNewNodes.find(org => org.id === sh.childId);
              const companyName = childOrg?.data?.companyName || sh.childId;
              const shares = sh.numberSharesOwned ? Number(sh.numberSharesOwned).toLocaleString() : '0';
              const percentage =  Number((sh.PercentageOfShares || 0).toFixed(3)) 
              return `(${companyName}-${shares}-${percentage}%)`;
            });

            const jointVentureDetails = jointVentures.map(jv => {
              const shares = jv.numberSharesOwned ? Number(jv.numberSharesOwned).toLocaleString() : '0';
              const percentage =  Number((jv.PercentageOfShares || 0).toFixed(3)) 
              return `(${jv.companyName}[JV]-${shares}-${percentage}%)`;
            });

            const allDetails = [...shareholderDetails, ...jointVentureDetails];
            rowData[formatHeaderLabel(field)] = allDetails.length > 0
              ? allDetails.join("&&")
              : "----";
          } else {
            rowData[formatHeaderLabel(field)] = item?.data?.[field] || "----";
          }
        }
      });
      rowData["Operating Company"] = item?.isBranch
        ? item?.data?.companyName?.split("-")[0]?.trim() || "----"
        : "----";
      return rowData;
    });

    // Excel Export
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    worksheet["!cols"] = Object.keys(selectedFields)
      .filter((f) => selectedFields[f])
      ?.map(() => ({ wch: 35 }));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Companies Report");
    XLSX.writeFile(workbook, `company_report_${getHongKongTimestamp()}.xlsx`);

    // Image-based PDF from React Flow
    const imageWidth = 1200; // Adjust width
    const imageHeight = 800; // Adjust height
    const node = document.querySelector('.react-flow__viewport');

    if (node) {
      const dataUrl = await toPng(node, {
        backgroundColor: 'white',
        width: imageWidth,
        height: imageHeight,
        style: {
          width: imageWidth + 'px',
          height: imageHeight + 'px',
        },
      });

      const pdf = new jsPDF({
        orientation: 'landscape',
        unit: 'px',
        format: [imageWidth, imageHeight],
      });

      pdf.addImage(dataUrl, 'PNG', 0, 0, imageWidth, imageHeight);
      pdf.save(`company_graph_${getHongKongTimestamp()}.pdf`);
    }
  };


  useEffect(() => {
    if (editedNewNodes?.length > 0) {
      const selecteds = editedNewNodes?.map((node) => node.data);
      dispatch(setSelectedNodes(selecteds));
    }
  }, [editedNewNodes, dispatch]);

  return (
    <>
      {open && (
        <GenerateReportSelectorModal
          open={open}
          handleClose={handleClose}
          handleCloseModalSubmit={(fields) => {
            handleClose();
            generateReport(fields); // Download both files after selection
          }}
        />
      )}
      <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
        <button
          className="btn btn-outline-primary"
          onClick={() => {
            if (selectedNodes?.length > 0) {
              handleOpen();
            }
          }}
        >
          Generate Report
        </button>
      </div>
    </>
  );
}
